import { useEffect, useState } from "react"
import { UserProvider } from "./userContext"
import { auth } from "../firebase";
import { Auth } from ".";
import { onAuthStateChanged } from "firebase/auth";

export const wrapAuth = (Component: React.ComponentType) => {
	const WrappedComponent = () => {
		const [isAuthenticated, setIsAuthenticated] = useState<boolean | null>(null);
		
		useEffect(() => {
			// Listen for auth state changes
			const unsubscribe = onAuthStateChanged(auth, (user) => {
				setIsAuthenticated(user !== null);
			});

			return () => unsubscribe();
		}, []);

		// Show loading state while checking auth
		if (isAuthenticated === null) {
			return (
				<div style={{ 
					display: 'flex', 
					justifyContent: 'center', 
					alignItems: 'center', 
					height: '100vh',
					color: '#ffffff'
				}}>
					Loading...
				</div>
			);
		}
		
		if (!isAuthenticated) {
			return Auth(setIsAuthenticated);
		}

		return <UserProvider><Component /></UserProvider>;
	};

	return WrappedComponent;
}

